import React, { createContext, useContext, useEffect, useState } from "react";

/**
 * Public-site light/dark theme.
 * Default is light (cream). The choice is remembered per device in localStorage.
 * The actual theme class (.coh-dark) is applied by PublicLayout on its own
 * wrapper so the admin area is never affected.
 */
const STORAGE_KEY = "coh-theme";
const ThemeContext = createContext({ theme: "light", toggleTheme: () => {}, setTheme: () => {} });

export const PublicThemeProvider = ({ children }) => {
  const [theme, setThemeState] = useState("light");

  useEffect(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved === "dark" || saved === "light") setThemeState(saved);
    } catch (e) {
      /* ignore storage errors */
    }
  }, []);

  const setTheme = (next) => {
    setThemeState(next);
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch (e) {
      /* ignore */
    }
  };

  const toggleTheme = () => setTheme(theme === "dark" ? "light" : "dark");

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const usePublicTheme = () => useContext(ThemeContext);
